<template>
  <div class="pc-nav">
    <div class='nav-container'>
      <img @click="toIndex" class="logo" alt="超级简历WonderCV LOGO" src="https://photo.wondercv.com/white-logo.png">

      <div class="right-part">
        <div>
          <appIcon/>
          <div class="line"></div>
          <!-- 未登录 -->
          <div v-if="!isLogin">
            <button @click='toLogin' class="margin-left">登录</button>
            <button class="action" @click='toReg'>注册</button>
          </div>
          <!-- 登陆 -->
          <div v-else>
            <personIcon/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { routerTo } from '~/assets/js/util'
  import personIcon from '../../../components/base/personIcon'
  import appIcon from '../../../components/base/phone'
  import {mapState} from "vuex";
  export default {
    name: "planning-nav",
    components: {personIcon, appIcon},
    methods: {
      toIndex(){
        routerTo('/')
      },
      toLogin() {
        routerTo('/auth-signin/?type=login')
      },
      toReg() {
        routerTo('/auth-signin/?type=login')
      },
    },
    computed:{
      ...mapState('me', ['isLogin']),
    }
  }
</script>

<style scoped lang="scss">
  .pc-nav {
    position: fixed;
    margin: 0;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 50px;
    z-index: 5;
    background-color: #202329;
    box-sizing: border-box;
    user-select:none;
    .nav-container {
      height: 100%;
      display: flex;
      justify-content: space-between;
      padding: 0 24px;
      align-items: center;
      .logo {
        height: 32px;
        cursor: pointer;
      }
      .right-part {
        height: 100%;
        & > div {
          display: flex;
          align-items: center;
          height: 100%;
          justify-content: flex-end;
        }

        .line {
          width: 1px;
          height: 16px;
          background: #36393E;
          margin: 0 16px;
        }

        button {
          width: 76px;
          height: 30px;
          border: 1px solid #797B7E;
          color: #fff;
          cursor: pointer;
          margin-left: 16px;
          border-radius: 15px;
          font-size: 14px;
          background: #202329;

          &.action {
            background: #FF6644;
            border: 1px solid #FF6644;
          }

          &:hover {
            border: 1px solid #fff;
          }

          &.action:hover {
            background: #FF856A;
            border: 1px solid #FF856A;
          }

          &.margin-left {
            margin-left: 0;
          }
        }
      }
    }
  }
</style>
